<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content">
    <div class="title-box">
      <span class="title">{{ "ROLE_MANAGEMENT" | translate }}</span>
      <button
        nz-button
        nzType="primary"
        (click)="isVisible = true"
        class="margin-left-auto add"
      >
        <bcsc-digi-icon type="digi-big-plus"></bcsc-digi-icon>
        <span>{{ "ADD" | translate }}</span>
      </button>
    </div>
    <div class="container">
      <nz-table
        #basicTable
        [nzData]="dataSource"
        [nzFrontPagination]="false"
        [nzServerRender]="true"
        [nzTotal]="pagination.total"
        [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize"
        [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        nzShowSizeChanger
        nzShowQuickJumper
        [nzShowTotal]="totalTemplate"
        [nzScroll]="{ y: 'calc(100vh - 311px)' }"
        [nzWidthConfig]="widthConfig"
      >
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.name | translate }}</th>
            <th>{{ "OPERATIONS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td *ngFor="let col of columns">{{ data[col.key] }}</td>
            <td class="opreations">
              <i
                nz-icon
                nzType="edit"
                nzTheme="outline"
                (click)="onEditRole(data)"
                nz-tooltip
                [nzTooltipTitle]="'EDIT' | translate"
              ></i>
              <i
                nz-icon
                nzType="delete"
                nzTheme="outline"
                nz-popconfirm
                [nzPopconfirmTitle]="
                  'DELETE_ROLE_POP_CONFIRM' | translate : { name: data.name }
                "
                (nzOnConfirm)="onDelete(data)"
                nzPopconfirmPlacement="topLeft"
                nz-tooltip
                [nzTooltipTitle]="'DELETE' | translate"
              ></i>
              <i
                nz-icon
                nzType="setting"
                nzTheme="outline"
                (click)="onAddPermission(data)"
                nz-tooltip
                [nzTooltipTitle]="'CONFIG_PERMISSION' | translate"
              ></i>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
      }}</ng-template>
    </div>
    <nz-modal
      [(nzVisible)]="isVisible"
      [nzTitle]="'NEW_ADD_ROLE' | translate"
      (nzOnCancel)="onCancel()"
      (nzOnOk)="onSave()"
      nzWidth="808px"
    >
      <ng-container *nzModalContent>
        <form
          nz-form
          [formGroup]="validateModuleForm"
          (ngSubmit)="isVisible = false"
        >
          <nz-form-item>
            <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="name">{{
              "ROLE_NAME" | translate
            }}</nz-form-label>
            <nz-form-control [nzSm]="20" [nzXs]="24" [nzErrorTip]="errorTpl">
              <input
                nz-input
                formControlName="name"
                id="name"
                [placeholder]="'PLEASE_INPUT_ROLE_NAME' | translate"
              />
              <ng-template #errorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{
                  "PLEASE_INPUT_ROLE_NAME" | translate
                }}</ng-container>
                <ng-container *ngIf="control.hasError('maxlength')">
                  {{ "ROLE_NAME_MAX_LENGTH" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="description">{{
              "ROLE_DESCRIPTION" | translate
            }}</nz-form-label>
            <nz-form-control
              [nzSm]="20"
              [nzXs]="24"
              [nzErrorTip]="'PLEASE_INPUT_ROLE_DESCRIPTION' | translate"
            >
              <textarea
                nz-input
                formControlName="description"
                id="description"
                [placeholder]="'PLEASE_INPUT_ROLE_DESCRIPTION' | translate"
              >
              </textarea>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </nz-modal>
    <nz-modal
      [(nzVisible)]="permissionModalVisible"
      [nzTitle]="'CONFIG_PERMISSION' | translate"
      (nzOnCancel)="permissionModalVisible = false"
      (nzOnOk)="addPermissionSave()"
      nzWidth="508px"
    >
      <ng-container *nzModalContent>
        <div *ngIf="permissionList.length" class="permission-form">
          <nz-tree
            [nzData]="permissionList"
            nzCheckable
            nzExpandAll
            nzCheckStrictly
            [nzCheckedKeys]="permissionDetail.permissionIds"
            (nzCheckBoxChange)="onPermissionChecked($event)"
          >
          </nz-tree>
        </div>
        <div *ngIf="!permissionList.length">
          <nz-empty nzNotFoundImage="simple"></nz-empty>
        </div>
      </ng-container>
    </nz-modal>
  </div>
</nz-spin>
